module.exports = __webpack_public_path__ + "static/media/figma.338e06da.png";